import React from 'react'

import {
  SettingOutlined,
  ShopOutlined,
  CodeSandboxOutlined,
  PartitionOutlined,
  FundViewOutlined,
  FileAddOutlined,
  FileDoneOutlined,
  UserSwitchOutlined,
  FileSyncOutlined,
  SyncOutlined,
  InboxOutlined,
  FileExclamationOutlined,
  DatabaseOutlined,
} from '@ant-design/icons'

import MapArticle from '../pages/management/MapArticle'

import Order from '../pages/order/Order'
import ReviewOrder from '../pages/review/ReviewOrder'
import LogCreateOrder from '../pages/systemLogging/LogCreateOrder'
import LogUpdatePo from '../pages/systemLogging/LogUpdatePo'
import LogJob from '../pages/systemLogging/LogJob'
import Material from '../pages/management/Material'
import Job from '../pages/management/Job'
import ArticleStandard from '../pages/management/ArticleStandard'
import User from '../pages/management/User'
import CreateOrder from '../pages/order/CreateOrder'
import SoCreated from '../pages/order/SoCreated'
import Email from '../pages/management/Email'
import ReviewDetail from '../pages/review/ReviewDetail'
import PageNotFound from '../pages/Layout/PageNotFound'
import ArticleStandardPrice from '../pages/management/ArticleStandardPrice'
import MasterSite from '../pages/masterData/MasterSite'

const checkRole = (value) => {
  const routeTemplate = [
    {
      role: ['ADMIN', 'DESIGNER', 'DESIGNER-DSB', 'DESIGNER-LEAD', 'MERCH', 'REVIEWER', 'STORE-MGR'],
      type: 'menu',
      path: '/order',
      menu: { icon: <ShopOutlined />, render: <>Order</> },
      route: { component: (props) => (<Order {...props} name="Order" />) },
    },
    {
      role: ['ADMIN', 'MERCH', 'REVIEWER'],
      type: 'menu',
      path: '/review',
      menu: { icon: <ShopOutlined />, render: <>Review Order</> },
      route: { component: (props) => (<ReviewOrder {...props} name="Review Order" />) },
    },
    {
      role: ['ADMIN', 'STORE-MGR', 'C3D-ADMIN'],
      type: 'subMenu',
      key: 'management',
      menu: { icon: <SettingOutlined />, render: <>Management</> },
      children: [{
        role: ['ADMIN', 'STORE-MGR'],
        type: 'menu',
        path: '/management/user',
        menu: { icon: <UserSwitchOutlined />, render: <>User</> },
        route: { component: (props) => (<User {...props} name="User management" />) },
      },
      {
        role: ['ADMIN'],
        type: 'menu',
        path: '/management/email',
        menu: { icon: <InboxOutlined />, render: <>Email</> },
        route: { component: (props) => (<Email {...props} name="Email" />) },
      },
      {
        role: ['ADMIN'],
        type: 'menu',
        path: '/management/job',
        menu: { icon: <SyncOutlined />, render: <>Job</> },
        route: { component: (props) => (<Job {...props} name="Job" />) },
      },
      {
        role: ['ADMIN'],
        type: 'menu',
        path: '/management/material',
        menu: { icon: <CodeSandboxOutlined />, render: <>Material</> },
        route: { component: (props) => (<Material {...props} name="Material Activity" />) },
      },
      {
        role: ['ADMIN'],
        type: 'menu',
        path: '/management/mapArticle',
        menu: { icon: <PartitionOutlined />, render: <>Map Article</> },
        route: { component: (props) => (<MapArticle {...props} name="Map Article" />) },
      },
      {
        role: ['ADMIN'],
        type: 'menu',
        path: '/management/articleStandard',
        menu: { icon: <FileDoneOutlined />, render: <>Article Standard</> },
        route: { component: (props) => (<ArticleStandard {...props} name="Article Standard" />) },
      },
      {
        role: ['C3D-ADMIN'],
        type: 'menu',
        path: '/management/ArticleStandardPrice',
        menu: { icon: <FileDoneOutlined />, render: <span style={{ fontSize: '0.8em' }}>Article Standard Price</span> },
        route: { component: (props) => (<ArticleStandardPrice {...props} name="Article Standard Price" />) },
      }],
    },
    {
      role: ['ADMIN'],
      key: 'systemLogging',
      type: 'subMenu',
      menu: { icon: <FundViewOutlined />, render: <>System Logging</> },
      children: [
        {
          role: ['ADMIN'],
          type: 'menu',
          path: '/systemLogging/createOrder',
          menu: { icon: <FileAddOutlined />, render: <>Create Order</> },
          route: { component: (props) => (<LogCreateOrder {...props} name="Log Create Order" />) },
        },
        {
          role: ['ADMIN'],
          type: 'menu',
          path: '/systemLogging/LogJob',
          menu: { icon: <FileSyncOutlined />, render: <>Job</> },
          route: { component: (props) => (<LogJob {...props} name="Log Job" />) },
        },
        {
          role: ['ADMIN'],
          type: 'menu',
          path: '/systemLogging/UpdatePo',
          menu: { icon: <FileExclamationOutlined />, render: <>Update Po</> },
          route: { component: (props) => (<LogUpdatePo {...props} name="Log Update Po" />) },
        },
      ],
    },
    {
      role: ['ADMIN', 'DESIGNER', 'DESIGNER-DSB', 'DESIGNER-LEAD', 'MERCH', 'REVIEWER', 'STORE-MGR'],
      type: 'route',
      path: '/order/create/:orderId',
      route: { component: (props) => (<CreateOrder {...props} name="CreateOrder" />) },
    },
    {
      role: ['ADMIN', 'DESIGNER', 'DESIGNER-DSB', 'DESIGNER-LEAD', 'MERCH', 'REVIEWER', 'STORE-MGR'],
      type: 'route',
      path: '/order/submit/:orderId',
      route: { component: (props) => (<SoCreated {...props} name="So Created Order" />) },
    },
    {
      role: ['ADMIN', 'MERCH', 'REVIEWER', 'DESIGNER', 'DESIGNER-DSB', 'DESIGNER-LEAD'],
      type: 'route',
      path: '/order/review/:orderId',
      route: { component: (props) => (<ReviewDetail {...props} name="Review Detail" />) },
    },
    {
      role: ['ADMIN', 'DESIGNER', 'DESIGNER-DSB', 'DESIGNER-LEAD', 'MERCH', 'REVIEWER', 'STORE-MGR'],
      type: 'route',
      path: '/order/complete/:orderId',
      route: { component: (props) => (<ReviewDetail {...props} name="Order Complete" />) },
    },
    {
      role: ['ADMIN', 'DESIGNER', 'DESIGNER-DSB', 'DESIGNER-LEAD', 'MERCH', 'REVIEWER', 'STORE-MGR'],
      type: 'route',
      path: '/page-not-found',
      route: { component: (props) => (<PageNotFound {...props} name="PageNotFound" />) },
    },
    {
      role: ['ADMIN'],
      key: 'masterData',
      type: 'subMenu',
      menu: { icon: <DatabaseOutlined />, render: <>Master Data</> },
      children: [
        {
          role: ['ADMIN'],
          type: 'menu',
          path: '/master-data/master-site',
          menu: { icon: <FileAddOutlined />, render: <>Master Site</> },
          route: { component: (props) => (<MasterSite {...props} name="Master Site" />) },
        },
      ],
    },
  ]
  const newRoute = []
  // eslint-disable-next-line no-restricted-syntax
  if (value) {
    for (const routeDetail of routeTemplate) {
      const haveMyRole = routeDetail?.role?.filter((e) => value.indexOf(e) !== -1)
      if (haveMyRole?.length > 0) {
        if (routeDetail?.type === 'subMenu') {
          const newChildren = []
          for (const child of routeDetail.children) {
            const haveMyRoleChild = child?.role?.filter((e) => value.indexOf(e) !== -1)
            if (haveMyRoleChild?.length > 0) { newChildren.push(child) }
          }
          routeDetail.children = newChildren
          newRoute.push(routeDetail)
        } else {
          newRoute.push(routeDetail)
        }
      }
    }
  }
  return newRoute
}
export default checkRole
